/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
import { LeadEntity, LeadCreateResponseDTO, LeadCreateRequestDTO, LeadReassignRequestDTO, LeadCallsResponseDTO, LeadCallRequestDTO, LeadSearchParams } from '../index';
import { SalesforcePostResponseDTO } from '../models/SalesforcePostResponseDTO';
import { LeadMotivationEnum, LeadStatusEnum } from '../models/Enums';
import { LeadReminderDTO } from '../models/Leads/LeadReminderDTO';

export class LeadsControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) { }

    /**
     * @returns LeadEntity
     * @throws ApiError
     */
    public getLeads(): CancelablePromise<Array<LeadEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/register/leads',
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    /**
     * @returns LeadEntity
     * @throws ApiError
     */
    public getSingleLead(id: string): CancelablePromise<Array<LeadEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/register/leads/{id}',
            path: { id },
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public createLead(createRequest: LeadCreateRequestDTO): CancelablePromise<LeadCreateResponseDTO> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/register/leads',
            body: createRequest,
            mediaType: 'application/json',
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public editLead(Id: string, createRequest: LeadCreateRequestDTO): CancelablePromise<LeadCreateResponseDTO> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/register/leads/{id}',
            body: createRequest,
            path: {
                'id': Id,
            },
            mediaType: 'application/json',
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public reassignLead(reassignLeadpayload: LeadReassignRequestDTO): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/register/leads/reassign',
            mediaType: 'application/json',
            body: reassignLeadpayload,
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public nurtureLead(leadId: string): CancelablePromise<LeadCreateResponseDTO> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/register/leads/nurture/{id}',
            path: {
                'id': leadId,
            },
            mediaType: 'application/json',
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public convertLead(leadId: string, newState?: LeadStatusEnum, payload?: any): CancelablePromise<SalesforcePostResponseDTO> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/register/leads/convert/{id}',
            path: {
                'id': leadId,
            },
            mediaType: 'application/json',
            query: { newState },
            body: payload || {},
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },

        });
    }

    public unqualifyLead(leadId: string, motivation: LeadMotivationEnum, newState?: LeadStatusEnum): CancelablePromise<SalesforcePostResponseDTO> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/register/leads/convert/{id}',
            path: {
                'id': leadId,
            },
            mediaType: 'application/json',
            query: { newState, motivation },
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public getCalls(leadId: string): CancelablePromise<Array<LeadCallsResponseDTO>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/register/leads/calls',
            mediaType: 'application/json',
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
            query: { leadId },
        });
    }

    public recordCall(leadCallData: LeadCallRequestDTO): CancelablePromise<SalesforcePostResponseDTO> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/register/leads/call',
            mediaType: 'application/json',
            body: leadCallData,
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },

        });
    }

    public getLeadFields(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/register/leads/fields',
            mediaType: 'application/json',
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public getLeadReminders(leadId: string): CancelablePromise<Array<LeadReminderDTO>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/register/leads/{id}/reminders',
            mediaType: 'application/json',
            path: {
                'id': leadId,
            },
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            }
        });
    }

    public createLeadReminder(leadId: string, dto: LeadReminderDTO): CancelablePromise<LeadReminderDTO> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/register/leads/{id}/reminders',
            mediaType: 'application/json',
            path: {
                'id': leadId,
            },
            body: dto,
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }


    public updateLeadReminder(leadId: string, reminderId: string, dto: LeadReminderDTO): CancelablePromise<LeadCreateResponseDTO> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/register/leads/{id}/reminders/{reminderId}',
            body: dto,
            path: {
                'id': leadId,
                'reminderId': reminderId
            },
            mediaType: 'application/json',
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public deleteLeadReminder(leadId: string, reminderId: string): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/register/leads/{id}/reminders/{reminderId}',
            path: {
                'id': leadId,
                'reminderId': reminderId
            },
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

    public pagedQuery(params: LeadSearchParams): CancelablePromise<{ totalCount: number; data: LeadEntity[] }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/register/leads/search',
            query: params,
            errors: {
                401: `Not Authorized`,
                403: `Not Allowed`,
            },
        });
    }

}
